import styled from "styled-components";

import { StepOneFormStyledProps as Props } from "./StepOneForm.types";

const StepOneFormStyled = styled.form<Props>`
  max-height: 40rem;
  overflow: auto;
  padding-right: 1.6rem;

  > * {
    &:not(:first-child) {
      padding-top: 2.4rem;
    }
  }

  .StepOneForm {
    &__title {
      color: var(--palette-black);
      font-size: 2.8rem;
      font-weight: 600;
    }

    &__text {
      color: var(--palette-black);
      font-size: 1.2rem;
      padding-top: 2.4rem;
    }

    &__radio-disabled {
      color: var(--palette-gray-s0-l70);
    }
  }
`;

export default StepOneFormStyled;
